import { GameVars } from "../GameVars";
import { DailyRewardState } from "../scenes/daily-reward/DailyRewardState";
import { GameConstants } from "../GameConstants";
import { FieldBoundaries } from "./FieldBoundaries";
import { PenaltyFootballFieldState } from "../scenes/penalty-scene/PenaltyFootBallFieldState";
import { PenaltyManager } from "../PenaltyManager";
import { FootballFieldState } from "../scenes/match-scene/FootballFieldState";
import { MatchManager } from "../MatchManager";
import { BallsManager } from "../BallsManager";
import { AudioManager } from "../AudioManager";

export class Ball extends Phaser.Sprite {

    public static BALL_ID: number = 0;

    private static samplePX: number[];
    private static samplePY: number[];

    public id: number;
    public ballOnFire: boolean;
    public isExtraBall: boolean;
    public allowUpdate: boolean;
    public canBeHit: boolean = false;
    public disappearing: boolean;

    private matchModel: any;
    private indexSampleArray: number;
    private timesExplosionAnimationPlayed: number;
    private f: number;
    private contactWithElasticElement: boolean;
    private extraBallStanding: boolean;

    constructor(game: Phaser.Game, x: number, y: number, isExtraBall?: boolean) {

        super(game, x, y, "texture_atlas_2");

        if (isExtraBall == null) {
            this.isExtraBall = false;
        } else {
            this.isExtraBall = isExtraBall;
        }

        this.extraBallStanding = false;
        this.disappearing = false;

        let tournamentData = GameVars.tournamentData;

        if (DailyRewardState.currentInstance || this.isExtraBall) {
            this.frameName = "balon_extra";
        } else if (tournamentData.name === GameConstants.OCEANIA_CUP) {
            this.frameName = "balon_oceania_cup";
        } else if (tournamentData.name === GameConstants.AFRICA_CUP) {
            this.frameName = "balon_africa_cup";
        } else if (tournamentData.name === GameConstants.ASIAN_CUP) {
            this.frameName = "balon_asia_cup";
        } else if (tournamentData.name === GameConstants.GOLD_CUP) {
            this.frameName = "balon_gold_cup";
        } else if (tournamentData.name === GameConstants.AMERICA_CUP) {
            this.frameName = "balon_america_cup";
        } else if (tournamentData.name === GameConstants.OLYMPIC_GAMES) {
            this.frameName = "balon_olympics";
        } else if (tournamentData.name === GameConstants.EUROCUP) {
            this.frameName = "balon_eurocup";
        } else if (tournamentData.name === GameConstants.CONFEDERATIONS_CUP) {
            this.frameName = "balon_confederations";
        } else if (tournamentData.name === GameConstants.WORLD_CUP) {
            this.frameName = "balon_world_cup";
        }

        this.anchor.set(.5);

        this.id = Ball.BALL_ID++;

        this.name = GameConstants.BALL;

        this.ballOnFire = false;

        this.timesExplosionAnimationPlayed = 0;

        this.contactWithElasticElement = false;
    }

    public update(): void {

        if (!this.allowUpdate || GameVars.paused || DailyRewardState.currentInstance) {
            return;
        }

        if (this.contactWithElasticElement) {
            this.contactWithElasticElement = false;
            this.capBallSpeed();
        }

        this.f++;

        if (this.y > GameConstants.GAME_HEIGHT - 20 && !this.disappearing) {

            if (this.x > FieldBoundaries.LEFT_POST_PX && this.x < (FieldBoundaries.LEFT_POST_PX + FieldBoundaries.DELTA_X_POST)) {
                if (PenaltyFootballFieldState.currentInstance) {
                    PenaltyManager.onGoal();
                } else if (FootballFieldState.currentInstance) {
                    MatchManager.onGoal();
                }
            } else {
                if (PenaltyFootballFieldState.currentInstance) {
                    PenaltyManager.onBallOutsideFootballField();
                } else if (FootballFieldState.currentInstance) {
                    MatchManager.onBallOutsideFootballField();
                }
            }

            this.disappearing = true;
            this.destroy();
        }

        if (this.f === 40) {

            this.f = 0;

            this.indexSampleArray = this.indexSampleArray < 12 ? this.indexSampleArray + 1 : 0;

            Ball.samplePX[this.indexSampleArray] = this.x;
            Ball.samplePY[this.indexSampleArray] = this.y;

            let d = Phaser.Math.distance(Ball.samplePX[0], Ball.samplePY[0], Ball.samplePX[12], Ball.samplePY[12]);

            // mirar la  coordenada x de la primera y la ultima del array
            // y si esta sen un rango de 4 px destruir la pelota
            if (d < 1.5) {

                if (this.isExtraBall) {
                    this.deductStandingExtraBall();
                } else {
                    this.returnBallToStartingPoint();
                }
            }
        }
    }

    public initPhysics(): void {

        this.allowUpdate = true;

        if (GameVars.penalties) {
            this.matchModel = PenaltyManager.currentInstance;
        } else {
            this.matchModel = MatchManager.currentInstance;
        }

        this.f = 0;
        this.indexSampleArray = 0;

        Ball.samplePX = [-20, -50, -80, -100, -10, -120, -5, -75, -150, -300, -90, -10, -30];
        Ball.samplePY = [-20, -50, -80, -100, -10, -120, -5, -75, -150, -300, -90, -10, -30];

        this.game.physics.p2.enable(this, GameConstants.SHOW_PHYSICS_BODIES);

        this.body.data.type = Phaser.Physics.P2.Body.DYNAMIC;

        this.body.setCircle(28);
        this.body.setMaterial(GameVars.getInstance().materials.ballMaterial);
        this.body.mass = .025;

        this.body.onBeginContact.add(this.onBeginContact, this);
    }

    public spin(): void {

        this.game.add.tween(this)
            .to({ angle: 360 }, 750, Phaser.Easing.Linear.None, true)
            .loop();
    }

    public setOnFire(): void {

        this.ballOnFire = true;
        this.frameName = "balon_fuego";
    }

    public attachToPlayer(player: Player): void {

        this.body.destroy();
        this.body = null;

        MatchManager.onBallAttachedToPlayer(player, this);
    }

    public onMagicPotion(): void {

        MatchManager.onMagicPotion();
    }

    private onBeginContact(body: any, shapeA: any, shapeB: any, equation: any): void {

        if (body === null) {
            return;
        }

        if (this.ballOnFire) {
            this.onBeginContactBallOnFire(body);
        } else {
            this.onBeginContactNormalBall(body);
        }
    }

    private onBeginContactNormalBall(body: any): void {

        if (body.sprite.name === GameConstants.MIDFIELDER_PEG || body.sprite.name === GameConstants.FORWARD_PEG) {

            if (!GameVars.isBallAttachedToPlayer && !GameVars.timeOver) {
                this.attachToPlayer(body.sprite);
            }

        } else if (
            body.sprite.name === GameConstants.CACTUS_PEG
            || body.sprite.name === GameConstants.CACTUS_PLANK
            || ((body.sprite.name === GameConstants.ELECTRIC_GOALKEEPER) && !body.sprite.cursed)
        ) {

            this.explode();

        } else if (body.sprite.name === GameConstants.EXTRA_BALL) {

            // informar al modelo
            MatchManager.onExtraBall(body.x, body.y, false);

        } else if (body.sprite.name === GameConstants.MAGIC_POTION) {

            this.onMagicPotion();
        } else if (body.sprite.name === GameConstants.ELASTIC_PEG || body.sprite.name === GameConstants.GOALKEEPER) {
            this.contactWithElasticElement = true;
        }

        if (body.sprite.canBeHit) {
            body.sprite.hit();
        }
    }

    private onBeginContactBallOnFire(body: any): void {

        if (body.sprite.name === GameConstants.MIDFIELDER_PEG || body.sprite.name === GameConstants.FORWARD_PEG) {

            if (!GameVars.isBallAttachedToPlayer && !GameVars.timeOver) {
                this.attachToPlayer(body.sprite);
            }

        } else if (body.sprite.name === GameConstants.EXTRA_BALL) {
            // informar al modelo
            MatchManager.onExtraBall(body.x, body.y, true);
            body.sprite.hit();
            return;
        } else if (body.sprite.name === GameConstants.MAGIC_POTION) {

            this.onMagicPotion();
            body.sprite.hit();
            return;
        } else if (body.sprite.name === GameConstants.ELASTIC_PEG || body.sprite.name === GameConstants.GOALKEEPER) {
            this.contactWithElasticElement = true;
        }

        // TODO usar otro booleano p ej canBeBurnt
        if (body.sprite.canBeBurnt) {
            body.sprite.burn();
        }
    }

    private returnBallToStartingPoint(): void {

        this.allowUpdate = false;
        this.body.destroy();
        this.body = null;

        // TODO el tiempo debe ser proporcional a la distancia del punto de chute para q la v sea cte
        let t: number = 1200; // era 1200
        this.game.add.tween(this)
            .to({ x: BallsManager.KICKOFF_PX, y: BallsManager.RETURN_TO_KICKOFF_PY }, t, Phaser.Easing.Quintic.InOut, true)
            .onComplete.add(this.onBallReturnedToStartingPoint, this);

        this.game.add.tween(this.scale)
            .to({ x: 1.75, y: 1.75 }, t / 2, Phaser.Easing.Quintic.In, true)
            .to({ x: 1, y: 1 }, t / 2, Phaser.Easing.Quintic.Out, true);

        //  para que tenga rotacion 0 al final como la pelota nueva que sale
        this.blendMode = 3;
        this.angle = 0;

        // un timer para que vuelva al blending mode normal
        this.game.time.events.add(300, function (): void {
            this.blendMode = 0;
        }, this);
    }

    private deductStandingExtraBall(): void {

        // poner un booleano para que solo llame una vez a match model
        // avisar al MatchModel
        if (!this.extraBallStanding) {
            MatchManager.onExtraBallStanding();
            this.extraBallStanding = true;
        }
    }

    private onBallReturnedToStartingPoint(): void {

        MatchManager.onBallReturnedToStartingPoint();
        this.destroy();
    }

    private explode(): void {

        this.allowUpdate = false;
        this.body.destroy();
        this.body = null;

        this.angle = 0;

        this.animations.add("explode", Phaser.Animation.generateFrameNames("balon_electrocutado", 1, 4, "", 4), 16, false);

        let animation: Phaser.Animation = this.animations.play("explode");
        animation.onComplete.add(this.disappear, this);

        this.timesExplosionAnimationPlayed = 1;

        AudioManager.getInstance().playEffect("electrocucion");
    }

    private disappear(): void {

        this.timesExplosionAnimationPlayed++;

        if (this.timesExplosionAnimationPlayed === 3) {
            this.implode();
        } else {
            let animation: Phaser.Animation = this.animations.play("explode");
            animation.onComplete.add(this.disappear, this);
        }
    }

    private implode(): void {

        this.game.add.tween(this.scale)
            .to({ x: 0, y: 0 }, 200, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(this.onBallOutsideTheField, this);
    }

    private onBallOutsideTheField(): void {

        this.matchModel.onBallOutsideFootballField();
        this.destroy();
    }

    private capBallSpeed(): void {

        if (this.body === null) {
            return;
        }

        // controlar la velocidad
        let x = this.body.velocity.x;
        let y = this.body.velocity.y;

        if (x * x + y * y > 5e5) {

            let a = Math.atan2(y, x);

            x = Math.cos(a) * 1800;
            y = - Math.sin(a) * 1800;

            this.body.velocity.x = x;

            if (this.body.velocity.y > 0) {
                this.body.velocity.y = Math.abs(y);
            } else {
                this.body.velocity.y = - Math.abs(y);
            }
        }
    }
}
